import React, { useContext } from 'react'
import { Button, Grid2, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import FilterValues from './FilterValues';
import GetFilterDropdown from './GetFilterDropdown'
import customToast from '../../genericComponents/CustomToast';
import Text, { translate } from '../../genericComponents/Text';
import LanguageText from '../../Layout/Contexts/LanguageTextContext';
import { FilterList } from '@mui/icons-material';

const FilterSideScreen = ({ setHeader, data, close }) => {

    const [column, setColumn] = useState(0);
    const [comparator, setComparator] = useState(0);
    const [value, setValue] = useState({ value: "", value2: 0 });
    const columnSetter = (value) => {
        setComparator(0);
        setColumn(value);
    }
    useEffect(() => {
        setHeader({icon:FilterList, text:"i18n_filters_" + typeName})
    }, [setHeader])

    const translations = useContext(LanguageText);
    const { columns, filters, setFilters, typeName } = data;
    const unfilterableDataTypes = ['avatar','ENUM','DateTime']
    let filteredColumns = []
    for (let i = 0; i < columns.length; i++) {       
        if (unfilterableDataTypes.find(y => y === columns[i].dataType)) continue;
        filteredColumns.push({ ...columns[i], text: translate(translations, `i18n_${typeName}_${columns[i].propertyName.toLowerCase()}`) })
    }
    filteredColumns.sort((a, b) => {
        if (a.text < b.text) {
            return -1;
        }
        if (a.text > b.text) {
            return 1;
        }
        return 0;
    })    
    const handleSetFilters = newFilters => {
        if (value.value === null || value.value === undefined) {
            alert('Cannot add filter. One or more values are missing.')
            customToast({ type: 'error', message: 'i18n_add_error' })
        } else {
            setFilters(newFilters)
            close();
        }
    }

    return (
        <Grid2 container spacing={1}>
            <Select onChange={e => columnSetter(e.target.value)} value={column} fullWidth>
                {filteredColumns.map((x, i) => <MenuItem value={i} key={i}><Text text={x.text} /></MenuItem>)}
            </Select>
            <Select onChange={e => setComparator(e.target.value)} value={comparator} fullWidth>
                {GetFilterDropdown(filteredColumns[column].dataType).map((x, i) => <MenuItem value={i} key={i}><Text text={x.label} /></MenuItem>)}
            </Select>
            <FilterValues column={filteredColumns[column]} compareIndex={comparator} onChange={setValue} value={value} />
            <Button fullWidth variant="contained" 
                onClick={() => handleSetFilters([
                    ...filters,
                    {
                        column: filteredColumns[column],
                        comparator: GetFilterDropdown(filteredColumns[column].dataType)[comparator],
                        filterValues: value
                    }
                ])}>
                <Text variant="button" color="white" text={"i18n_filter_add_" + typeName} />
            </Button>
        </Grid2>
    )
}
export default FilterSideScreen;
